var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.6875 24.8115C57.253 25.7975 64.5242 33.8566 64.5242 43.4728H51.4952V41.6181C51.4952 38.3932 49.1509 35.7158 46.0736 35.197V25.7185C46.0736 25.1444 46.5702 24.6963 47.1413 24.7552L47.6875 24.8115Z",
    fill: "white",
    fillOpacity: 0.96
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4741 45.4824H25.4487V61.4654C25.4487 72.2548 34.1953 81.0014 44.9847 81.0014C55.7741 81.0014 64.5206 72.2548 64.5206 61.4654V45.4824H51.4981V47.335C51.4981 50.9315 48.5826 53.847 44.9861 53.847C41.3896 53.847 38.4741 50.9315 38.4741 47.335V45.4824Z",
    fill: "white",
    fillOpacity: 0.96
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9819 37.103C42.5843 37.103 40.6406 39.0467 40.6406 41.4443V47.4054C40.6406 49.8031 42.5843 51.7468 44.9819 51.7468C47.3796 51.7468 49.3233 49.8031 49.3233 47.4054V41.4444C49.3233 39.0467 47.3796 37.103 44.9819 37.103Z",
    fill: "white",
    fillOpacity: 0.96
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2854 24.8154C32.7199 25.8014 25.4487 33.8605 25.4487 43.4767H38.4719V41.62C38.4719 38.3931 40.8191 35.7143 43.8993 35.1979V25.7224C43.8993 25.1483 43.4027 24.7002 42.8316 24.7591L42.2854 24.8154Z",
    fill: "#FF744E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 27L26.341 28.591",
    stroke: "#FF744E",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 24.75V27",
    stroke: "#FF744E",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 31.5L24.75 31.5",
    stroke: "#FF744E",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9525 19.25H17.586L18.4365 17.684C18.6795 17.2385 18.8955 16.793 19.1385 16.3745H19.206C19.4625 16.793 19.7325 17.2385 19.9755 17.684L20.9475 19.25H22.635L20.2455 15.551L22.4595 11.825H20.8395L20.07 13.31C19.854 13.742 19.6515 14.147 19.449 14.5655H19.395C19.152 14.147 18.909 13.742 18.693 13.31L17.802 11.825H16.128L18.342 15.389L15.9525 19.25ZM23.4365 19.25H29.8625V17.927H27.338C26.8385 17.927 26.2175 17.981 25.7045 18.035C27.77 15.8615 29.39 14.0795 29.39 12.3245C29.39 10.556 28.2155 9.4085 26.393 9.4085C25.097 9.4085 24.2195 9.962 23.3555 10.88L24.2465 11.744C24.773 11.15 25.421 10.6505 26.204 10.6505C27.311 10.6505 27.878 11.339 27.878 12.392C27.878 13.9175 26.204 15.632 23.4365 18.3455V19.25Z",
    fill: "#FF744E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIcon);
export default __webpack_public_path__ + "static/media/defaultIcon.eefb53396c3cf8e539fe46f14c464aff.svg";
export { ForwardRef as ReactComponent };